@import '~style-sheet-helpers/core.less';
@import '../../../../../../../../constants/spacing.module.less';
@import '../../../../../../../../constants/screen-width-breakpoints.module.less';

.refund-assist-section {
  width: 80%;
  margin: @space-64 auto;
  text-align: left;

  @media @mobile, @ultramobile {
    width: 100%;
    margin: @space-24 auto;
  }
}

.refund-assist-card {
  padding: @space-0;
  gap: unset; /* Override Card component's default gap */
  width: 100%;
}

.refund-assist-card-toggle {
  border-radius: 8px;
  border: 1px solid var(--gray-E4E5E7);
  padding: @space-16;
  margin: @space-16;
}

.refund-assist-card-toggle .toggle-row {
  justify-content: space-between;
  align-items: center;
}

.refund-assist-card-toggle .terms-and-conditions {
  display: flex;
  line-height: @space-24;
  align-items: center;
}

.refund-assist-card-toggle .terms-and-conditions svg {
  height: 14px;
  margin-left: 5px;
  margin-bottom: -2px;
}

.disclaimer-wrapper {
  background-color: var(--gray-F9FAFB);
}

.disclaimer-content {
  border-top: 1px solid var(--gray-E4E5E7);
  padding: @space-16;
}

.disclaimer-toggle-button {
  display: flex;
  align-items: center;
  color: var(--blue-1D5AD8);
  padding-left: @space-16;
  padding-bottom: @space-16;
}

.disclaimer-toggle-button .disclaimer-toggle-text {
  cursor: pointer;
}

.disclaimer-toggle-button .disclaimer-arrow {
  margin-left: @space-4;
  height: 16px;
  width: 16px;
}
